import { render } from "./HomeDepartment.vue?vue&type=template&id=0ca279c6&scoped=true&ts=true"
import script from "./HomeDepartment.vue?vue&type=script&lang=ts"
export * from "./HomeDepartment.vue?vue&type=script&lang=ts"

import "./HomeDepartment.vue?vue&type=style&index=0&id=0ca279c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca279c6"]])

export default __exports__